module.exports = __webpack_public_path__ + "media/images/footer-582dc84ef2b86b23d3f0458317864be7.jpg";